import { makeStyles } from '@material-ui/core/styles';
import { orangered } from 'styles/abstract/variables';

export const makeRadioClasses = makeStyles(
    {
        root: {
            color: orangered,

            '&$checked': {
                color: orangered,
            },
        },
        checked: {},
    },
    { index: 1 },
);
